function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadataAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90caf9"
    },
    d: "M39 16v7h-6v-7h-2v7h-6v-7h-2v7h-7v2h7v6h-7v2h7v6h-7v2h25V16Zm0 9v6h-6v-6Zm-14 0h6v6h-6Zm0 8h6v6h-6Zm8 6v-6h6v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00bcd4"
    },
    d: "M40 8H8v32h8V16h24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0097a7"
    },
    d: "M7 7v34h10V17h24V7Zm2 16v-6h6v6Zm6 2v6H9v-6Zm2-16h6v6h-6Zm8 0h6v6h-6ZM15 9v6H9V9ZM9 39v-6h6v6Zm30-24h-6V9h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43a047"
    },
    d: "M46 36c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M34 30h4v12h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M30 34h12v4H30Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadataAdd);
export default __webpack_public_path__ + "static/media/metadataAdd.0feeaddc28b031a9eacaa4dd789638e5.svg";
export { ForwardRef as ReactComponent };